import * as React from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Box, Chip, FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Select, Typography} from '@mui/material';
import { useTheme } from '@mui/styles';
import DateTimePicker_Dsas from '../../../../dsasComponents/DateTimePicker_Dsas.js';
import useStyles from '../../../../styles/global-mui.js';
import Select_Dsas from '../../../../dsasComponents/Select_Dsas.js';
import { discipline_all, getActualSeason, getDays, season_all } from '../../../../bdd/bddSTUB.js';
import { getUserProvider, isAdminDSAS } from '../../../../actions/auth.js';
import SelectGroupProvider from '../../../../dsasComponents/SelectGroupProvider.js';
import { useFetch } from '../../../../filters/useFetch.js';
import { fetchCompetitions, fetchMatchs, fetchTeams } from '../../../../api/index.js';
import { FETCH_ALL_COMPETITION, FETCH_ALL_MATCH, FETCH_ALL_TEAM } from '../../../../constants/actionTypes.js';
import SelectMultiUser from '../../../../dsasComponents/SelectMultiUser.js';
import DsasButton from '../../../../v1/components/DsasButton/DsasButton.js';
import { faArrowRotateRight, faCancel, faCheck } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { usePermissions } from '../../../../permissions/usePermissions.js';
import { PERMISSIONS } from '../../../../permissions/permissionKeys.js';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }


const LivePopupCreator = ({open, setOpen, state, setState, handleConfirm, handleCancel, initialState}) => {
    const classes = useStyles();

    const theme = useTheme();

    const currentUser = useSelector(state => state.authentication.currentUser);
    const provider = currentUser?.groups; // ou currentUser?.groups si c’est ça le "provider"
  

      const [disciplineFilter, setDisciplineFilter] = React.useState('')
      const [competitionFilter, setCompetitionFilter] = React.useState('')
      const [dayFilter, setDayFilter] = React.useState('')
      const [seasonFilter, setSeasonFilter] = React.useState(getActualSeason())
      const [providerFilter, setProviderFilter] = React.useState(provider);

      const { getPermission } = usePermissions();
      const providerPermission = getPermission(PERMISSIONS.FILTER_PROVIDER);

      

      // FILTERS
      const [filters, setFilters] = React.useState({discipline : disciplineFilter, competition : competitionFilter, day : dayFilter, provider : providerFilter, season : seasonFilter})
      React.useEffect(() => {
        setFilters({discipline : disciplineFilter, competition : competitionFilter, day : dayFilter, provider : providerFilter, season : seasonFilter})
      }, [disciplineFilter, competitionFilter, dayFilter, providerFilter, seasonFilter])

      const [matchs, loadingMatch] = useFetch(fetchMatchs, filters, ['competition', 'day'], FETCH_ALL_MATCH)
      const [competitions_all, loadingCompetition] = useFetch(fetchCompetitions, filters, undefined, FETCH_ALL_COMPETITION)
      const [teams, loadingTeam] = useFetch(fetchTeams, filters, ['competition'], FETCH_ALL_TEAM)

      // Permet de conserver tous les matchs chargés
      const [loadedMatchs, setLoadedMatchs] = React.useState([])
      React.useEffect(() => {
        setLoadedMatchs(s => s.concat(matchs))

      }, [matchs])

      const getDaysAvailable = React.useCallback(() => {
        let days = []
        if(competitionFilter===''){

            // On récupère le max de nbDays et le max de nbTeamFinalPhase
            const [maxNbDays, maxNbTeamFinalPhase] = competitions_all.reduce((acc, curr) => {
                acc = [Math.max(acc[0], curr.nbDays), Math.max(acc[1], curr.nbTeamFinalPhase)]

                return acc
            }, [0, 0])

            days = getDays(maxNbDays, maxNbTeamFinalPhase)
        }else{
            let selectedCompetition = competitions_all.find(c => c._id === competitionFilter)

            if(selectedCompetition)
              days = getDays(selectedCompetition.nbDays, selectedCompetition.nbTeamFinalPhase)
        }

        return days
      }, [matchs, competitionFilter])


      const getFilteredMatches = React.useCallback(() => {
        return matchs
        .filter(m => providerFilter === '' || m.provider === providerFilter)
        .filter(m => disciplineFilter === '' || m.discipline === disciplineFilter)
        .filter(m => competitionFilter === '' || m.competition === competitionFilter)
        .filter(m => dayFilter === '' || m.day == dayFilter)
        .sort((a,b) => a.day - b.day)

      }, [matchs, disciplineFilter, competitionFilter, dayFilter, providerFilter])


      const handleSelectMatch = (event) => {
        // On veut récupérer la discipline du match
        const newDiscipline = matchs.reduce((acc, m) => {
          if(event.includes(m._id)){
            if(!acc)
              acc = m.discipline
            else if(acc !== m.discipline)
              acc = 'mix'
          }
          return acc
        }, state.discipline)

        setState(s => ({...s, matchs : event, discipline : newDiscipline}))
      }

      const handleChangeName = (e) => {
        setState(s => ({...s, name : e.target.value}))
      }

      const handleChangeDateTime = (value) => {
        let targetName = "dateTime"
        setState(s => ({...s, [targetName]: value}))
    }

     const handleClear = () => {
        setState(JSON.parse(JSON.stringify(initialState)));

        setDisciplineFilter('');
        setCompetitionFilter('');
        setDayFilter('');
        setSeasonFilter(getActualSeason());
        setProviderFilter(provider);
      };

      const handleCancelPopup = () => {
        handleClear();
        handleCancel();
      }

      const handleConfirmPopup = () => {
        handleConfirm();
        handleClear();
      }

      const getMatchLabel = React.useCallback((value) => {

        const match = loadedMatchs.find(p => p._id === value)

        if(!match)
          return ''

        const homeTeam = teams.find(t => t._id === match.homeTeam)
        const awayTeam = teams.find(t => t._id === match.awayTeam)

        if(!homeTeam || !awayTeam)
            return ''

        return homeTeam.name + ' - ' + awayTeam.name + ' ('+ new Date(match.dateTime).toLocaleString() + ')'
      }, [loadedMatchs, teams])

    return (
        <Dialog open={open} fullWidth maxWidth={"lg"}>

             <Box className='centered-wrapper padding-wrapper'>
                <Typography variant="h1" className='page-title'>Création de direct</Typography>
              </Box>
                    
              <Box className='large-separator'></Box>

             {/**POPUP BODY CONTENT*/}
              <DialogContent sx={{padding:'2rem', paddingTop:0, paddingBottom:0}}>
                {/**FORM*/}
                <Box className='large-padding'>
                  <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={12} md>
                        {/* Live name */}
                        <TextField 
                            className={classes.customInput}
                            name="lastname" 
                            variant="outlined"
                            label="Nom" 
                            fullWidth 
                            value={state.name}
                            onChange={handleChangeName}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={3}>
                        {/* Live date */}
                        <DateTimePicker_Dsas 
                          className={classes.customInput}
                          label={"Début du direct"}
                          name={"dateTime"}
                          value={state.dateTime}
                          onChange = {handleChangeDateTime}
                      />
                      </Grid>
                    </Grid>  
                  
                    <Box className='medium-padding'></Box>
                    <Box className='large-separator'></Box>
                    <Box className='small-padding'></Box>

                        <Typography variant="h6" className='page-title' >Matchs du direct</Typography>
                        <Box className='small-padding'></Box>
                        {/* FILTERS */}
                        
                        <Grid container spacing={1.5}>
                          <Grid item xs={12} sm md>
                            <Select_Dsas
                              fullWidth
                              className={classes.customInput}
                              labelId = {"discipline_label"}
                              label = {"Discipline"}
                              selectId = {"discipline"}
                              name = {"discipline"}
                              value = {disciplineFilter}
                              items = {discipline_all}
                              onChange = {(e) => setDisciplineFilter(e.target.value)}
                              onReset = {(e) => setDisciplineFilter('')}
                          />
                          </Grid>
                          <Grid item xs={12} sm md>
                            <Select_Dsas
                              fullWidth
                              className={classes.customInput}
                              labelId = {"season_label"}
                              label = {"Saison"}
                              selectId = {"season"}
                              name = {"season"}
                              value = {seasonFilter}
                              items = {season_all}
                              onChange = {(e) => setSeasonFilter(e.target.value)}
                              onReset = {(e) => setSeasonFilter('')}
                          />
                          </Grid>
                          <Grid item xs={12} sm md>
                            <Select_Dsas
                              fullWidth
                              isError={!competitionFilter}
                              className={classes.customInput}
                              labelId = {"competition_label"}
                              label = {"Competition"}
                              selectId = {"competition"}
                              name = {"competition"}
                              value = {competitionFilter}
                              items = {competitions_all}
                              onChange = {(e) => setCompetitionFilter(e.target.value)}
                              onReset = {(e) => setCompetitionFilter('')}
                          />
                          </Grid>
                          <Grid item xs={12} sm md>
                            <Select_Dsas
                            fullWidth
                            isError = {!dayFilter}
                            className={classes.customInput}
                            labelId = {"day_label"}
                            label = {"Journée"}
                            selectId = {"day"}
                            name = {"day"}
                            value = {dayFilter}
                            items = {getDaysAvailable()}
                            onChange = {(e) => setDayFilter(e.target.value)}
                            onReset = {(e) => setDayFilter('')}
                          />
                          </Grid>
                          {providerPermission?.allowed && (
                          <Grid item xs={12} sm md>
                           <SelectGroupProvider value={providerFilter} onChange={(e) => setProviderFilter(e.target.value)}/>
                          </Grid>
                          )}
                        </Grid>

                        <Box className='medium-padding'></Box>
                    
                        {/* MATCHS */}
                        <Grid container spacing={1.5}>
                          <Grid item xs={12} sm={12} md={12}>
                            <FormControl fullWidth className={classes.customInput}>
                                <InputLabel id="demo-multiple-chip-label">Matchs</InputLabel>
                                <Select
                                className={classes.customInput}
                                labelId="demo-multiple-chip-label"
                                id="demo-multiple-chip"
                                multiple
                                value={state.matchs}
                                onChange={(event) => {
                                    const {
                                    target: { value },
                                    } = event;
                                    handleSelectMatch(
                                    // On autofill we get a stringified value.
                                    typeof value === 'string' ? value.split(',') : value,
                                    );
                                }}
                                input={<OutlinedInput id="select-multiple-chip" label="Joueurs" />}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value) => (
                                        <Chip key={value} label={getMatchLabel(value)} />
                                    ))}
                                    </Box>
                                )}
                                MenuProps={MenuProps}
                                >
                                {getFilteredMatches().map(match => (
                                    <MenuItem
                                    key={match._id}
                                    value={match._id}
                                    style={getStyles(match._id, state.matchs, theme)}
                                    className={classes.customListItem}
                                    >
                                    {getMatchLabel(match._id)}
                                    </MenuItem>
                                ))}
                                </Select>
                            </FormControl>
                          </Grid>
                        </Grid>

                        <Box className='medium-padding'></Box>

                        <Grid container spacing={1.5}>
                          <Grid item xs={12} sm={6} md={6}>
                            {/* Group */}
                              <FormControl fullWidth 
                                className={classes.customInput}
                                variant="standard" 
                                margin="normal"
                                sx={{marginTop:0}}
                                >
                                {isAdminDSAS() && 
                                <SelectGroupProvider value={state.provider} onChange={(e) => setState(s => ({...s, provider : e.target.value, userNames: []}))}/>}
                              </FormControl>            
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            {/* Users */}
                              <SelectMultiUser className={classes.customInput} handleChangeUsers={(users) => setState(s => ({...s, userNames : users}))} usersSelected={state.userNames} provider={state.provider}></SelectMultiUser>
                          </Grid>
                        </Grid>
              </Box>
            </DialogContent>

            <Box className='large-separator'></Box>
            <DialogActions sx={{justifyContent:'center'}}>
            <Box className='centered-wrapper'>
              <DsasButton icon={faArrowRotateRight} label="Reset" onClick={() => handleClear()} variant = 'secondary'/>
              <DsasButton icon={faCancel} label="Annuler" onClick={() => handleCancelPopup()} variant = 'secondary'/>
              <DsasButton icon={faCheck} label={'Enregistrer le direct'} onClick={() => handleConfirmPopup()} disabled={!state.name || state.matchs.length === 0} variant = 'secondary'/>
            </Box>
            </DialogActions>                      

        </Dialog> 
    )
}

export default LivePopupCreator